import React from 'react';

type DayTab = {
  id: string;
  label: string;
  dayNumber?: string;
};

type Props = {
  days?: DayTab[];
  activeDayId: string;
  onChange: (dayId: string) => void;
};

const ScheduleDayTabs = React.forwardRef<HTMLDivElement, Props>(
  function ScheduleDayTabs({ days = [], activeDayId, onChange }, ref) {
    const activeButtonRef = React.useRef<HTMLButtonElement | null>(null);

    React.useEffect(() => {
      activeButtonRef.current?.scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest',
      });
    }, [activeDayId]);

    if (!Array.isArray(days) || !days.length) return null;

    return (
      <div
        ref={ref}
        className="schedule-day-tabs"
        role="tablist"
        aria-label="Dias da programação"
      >
        {days.map((day) => {
          const isActive = day.id === activeDayId;

          return (
            <button
              key={day.id}
              ref={isActive ? activeButtonRef : null}
              type="button"
              role="tab"
              aria-selected={isActive}
              className={`schedule-day-tabs__item ${isActive ? 'is-active' : ''}`}
              onClick={() => onChange(day.id)}
            >
              <span className="schedule-day-tabs__inner">
                <span className="schedule-day-tabs__weekday">{day.label}</span>
                <span className="schedule-day-tabs__day-number">
                  {day.dayNumber || '--'}
                </span>
              </span>
            </button>
          );
        })}
      </div>
    );
  },
);

export default ScheduleDayTabs;
